import auth from '@/service/AuthService'

export default {
  currentUserHomeRoute() {
    // SSP-3191
    if (auth.hasRole('ROLE_RUNAS')) {
      return { name: 'runAs' }
    }
    if (auth.hasRole('ROLE_SECTION_ACTIVATOR')) {
      return { name: 'activator-home' }
    }
    if (auth.hasRole('ROLE_ORDER_MANAGER') || auth.hasRole('ROLE_CODE_MANAGER')) {
      return { name: 'orders' }
    }
    if (auth.hasRole('ROLE_VALIDATION_LOG_VIEWER')) {
      return { name: 'validationLog' }
    }
    return { name: 'userPreferences' }
  }
}



// WEBPACK FOOTER //
// ./src/router/routingRules.js